// src/utils/period.js
import { iso, parseISO, addDays } from "./date";

export function resolvePeriod(mode, anchorIso, customFrom, customTo) {
  if (mode === "custom") return { from: customFrom, to: customTo };

  const d = parseISO(anchorIso);
  const y = d.getFullYear();

  if (mode === "month") {
    const m = d.getMonth();
    return { from: iso(new Date(y, m, 1)), to: iso(new Date(y, m + 1, 0)) };
  }
  if (mode === "quarter") {
    const q = Math.floor(d.getMonth() / 3);
    return {
      from: iso(new Date(y, q * 3, 1)),
      to: iso(new Date(y, q * 3 + 3, 0)),
    };
  }
  if (mode === "year") {
    return { from: iso(new Date(y, 0, 1)), to: iso(new Date(y, 11, 31)) };
  }
  return { from: anchorIso, to: anchorIso };
}

export function resolveReminderPeriod(period, now, fromStr, toStr) {
  const d = new Date(now);
  const day = d.getDay(); // 0 - вс, 1 - пн
  const diffToMonday = day === 0 ? 6 : day - 1;

  const startOfThisWeek = addDays(d, -diffToMonday);
  const startOfPrevWeek = addDays(startOfThisWeek, -7);
  const endOfPrevWeek = addDays(startOfThisWeek, -1);

  if (period === "this_week") {
    return { from: iso(startOfThisWeek), to: iso(addDays(startOfThisWeek, 6)) };
  }
  if (period === "prev_week") {
    return { from: iso(startOfPrevWeek), to: iso(endOfPrevWeek) };
  }
  if (period === "custom") {
    return { from: fromStr, to: toStr };
  }
  return null;
}
